import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ClientService } from '../../client.service';

import { Translations } from './translations.model';

@Injectable()
export class TranslationsApi {
  private readonly endPointPrefix = 'translations';
  private readonly ver = 'v2';

  constructor(private clientService: ClientService) {}

  /**
   * Returns Phraseapp translations
   * @param langCode
   * @param phraseappID
   */
  getTranslationsFromPhraseappProject(langCode: string, phraseappID): Observable<Translations> {
    const endpoint = `${this.endPointPrefix}/${this.ver}/phraseapp-proxy/projects/${phraseappID}/locales/${langCode}/download?file_format=simple_json`;

    return this.clientService.get(endpoint);
  }
}
